// extracted by mini-css-extract-plugin
export default {"cls1":"FundingList-Label_cls1__5wBKm","cls2":"FundingList-Label_cls2__U98xt FundingList-Label_cls1__5wBKm"};